import i18n from '@/natives/libs/i18n';
import getInitLocale from '@pro/common/utils/getInitLocale';

i18n.locale = getInitLocale();
i18n.fallbackLocale = 'en';
i18n.messages = window.__HPP_I18N_MESSAGES__ || {};
if (Object.keys(i18n.messages).length < 1) {
  window.location.reload();
}
i18n.replaceHTML();
console.log('language replace');

export default i18n;
